import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const FacultyTemplate = ({ faculty }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("Undergraduate");
  const location = useLocation();

  if (!faculty) {
    return (
      <div className="text-center py-10">
        <h1 className="text-3xl font-bold">Faculty Not Found</h1>
        <p className="mt-4 text-lg text-gray-600">
          The faculty you're looking for does not exist.
        </p>
      </div>
    );
  }

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Smooth scrolling
    });
  }, []);

  const allProgrammes = faculty.programmes
    ? faculty.programmes.flatMap((programGroup) =>
        programGroup.items.map((item) => ({
          category: programGroup.category,
          name: item.name,
          link: item.link,
          pofstudyimg: item.pofstudyimg, // Include pofstudyimg
        }))
      )
    : [];

  const handleCategorySelect = (category) => {
    setSelectedCategory(category);
    setDropdownOpen(false);
  };

  const filteredProgrammes = selectedCategory
    ? allProgrammes.filter((p) => p.category === selectedCategory)
    : [];

  return (
    <>
      <div className="faculty-page">
        <div className="flex items-center justify-center px-4">
          <div className="py-10 inline-block w-full ">
            <div className="flex flex-col items-center">
              <div className="h-0.5 bg-gray-400 w-full"></div>
              <p className="py-5 text-2xl md:text-4xl font-semibold text-center">
                {faculty.name}
              </p>
              <div className="h-0.5 bg-gray-400 w-full"></div>
            </div>
          </div>
        </div>

        <div
          className="relative flex items-center justify-center h-64 md:h-80 md:mb-14 mb-7"
          style={{
            backgroundImage: `url(${faculty.image})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-40"></div>

          <p className="text-lg font-semibold text-white text-center max-w-xl mx-auto relative px-4">
            {faculty.welcome}
          </p>
        </div>
        <div className="md:mb-14 mb-6 px-4 md:px-10 max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row items-center">
            <div className="w-full md:w-1/2 flex justify-center mb-6 md:mb-0">
              <iframe
                className="w-full h-64 rounded-lg mx-4"
                src={faculty.youtubelink}
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="w-full md:w-1/2 md:pl-6">
              <div className="border-2 border-sdorange md:inline-block rounded-lg mb-4">
                <p className="font-bold text-xl m-2 text-center">
                  What the Faculty is About
                </p>
              </div>
              <p className="text-gray-600 text-sm md:text-base leading-relaxed text-justify">{faculty.about}</p>
            </div>
          </div>
        </div>

        <div>
          <div className="relative">
            <div className=" px-4 py-5 flex justify-center font-bold">
              <h2 className="text-lg text-center md:text-xl font-bold text-gray-800">
                Our Programs Of Study
              </h2>
            </div>

            {faculty.programmes && (
              <div className="p-4 md:p-8 bg-gradient-to-b from-sddarkgray to-transparent">
                <div className="max-w-6xl mx-auto">
                  <div className="flex justify-center flex-wrap gap-4 mb-8">
                    {faculty.programmes.map((cat, catIndex) => (
                      <div
                        key={catIndex}
                        onClick={() => handleCategorySelect(cat.category)}
                        className="cursor-pointer p-4 bg-sdbodywhite rounded-xl shadow hover:bg-slate-700 text-gray-800 hover:text-white  transition duration-300 min-w-[100px]"
                      >
                        <p className="font-semibold text-center ">
                          {cat.category}
                        </p>
                      </div>
                    ))}
                  </div>
                  {selectedCategory ? (
                    <div>
                      <div className="flex flex-wrap gap-4 justify-center">
                        {filteredProgrammes.map((programme, index) => (
                          <div
                            key={index}
                            style={{
                              backgroundImage: `url(${programme.pofstudyimg})`,
                              backgroundSize: "cover",
                              backgroundPosition: "center",
                              backgroundRepeat: "no-repeat",
                            }}
                            className="relative flex flex-col p-4 rounded-2xl shadow-xl w-64 h-64 justify-between"
                          >
                            <div className="absolute inset-0 bg-black bg-opacity-60 rounded-2xl border-4 border-white animate-border-pulse"></div>

                            <div className="relative flex-grow flex items-center justify-center">
                              <p className="border-2 border-white p-2 rounded-lg text-lg font-semibold text-gray-100 text-center z-10">
                                {programme.name}
                              </p>
                            </div>

                            {programme.description && (
                              <div className="relative mt-2 text-sm text-white text-center z-10">
                                {programme.description}
                              </div>
                            )}

                            <div className="relative text-center mt-4 z-10">
                              <Link
                                to={programme.link}
                                state={
                                  programme.link === "/pagenotopenyet"
                                    ? { backgroundLocation: location }
                                    : undefined
                                }
                              >
                                <button
                                  type="button"
                                  class="flex justify-center gap-2 items-center mx-auto shadow-xl text-gray-700 text-md bg-gray-50 backdrop-blur-md lg:font-semibold isolation-auto border-gray-50 before:absolute before:w-full before:transition-all before:duration-700 before:hover:w-full before:-left-full before:hover:left-0 before:rounded-full before:bg-emerald-500 hover:text-gray-50 before:-z-10 before:aspect-square before:hover:scale-150 before:hover:duration-700 relative z-10 px-2 py-1 overflow-hidden border-2 rounded-full group"
                                >
                                  Learn More
                                  <svg
                                    class="w-7 h-7 justify-end group-hover:rotate-90 group-hover:bg-gray-50 text-gray-50 ease-linear duration-300 rounded-full border border-gray-700 group-hover:border-none p-2 rotate-45"
                                    viewBox="0 0 16 19"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M7 18C7 18.5523 7.44772 19 8 19C8.55228 19 9 18.5523 9 18H7ZM8.70711 0.292893C8.31658 -0.0976311 7.68342 -0.0976311 7.29289 0.292893L0.928932 6.65685C0.538408 7.04738 0.538408 7.68054 0.928932 8.07107C1.31946 8.46159 1.95262 8.46159 2.34315 8.07107L8 2.41421L13.6569 8.07107C14.0474 8.46159 14.6805 8.46159 15.0711 8.07107C15.4616 7.68054 15.4616 7.04738 15.0711 6.65685L8.70711 0.292893ZM9 18L9 1H7L7 18H9Z"
                                      class="fill-gray-800 group-hover:fill-gray-800"
                                    ></path>
                                  </svg>
                                </button>
                              </Link>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  ) : (
                    <div className="text-center text-gray-700">
                      <p>
                        Select a category above to see more details on its
                        programs.
                      </p>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="max-w-6xl mx-auto px-5">
          <div className="flex justify-center my-10 px-4">
            <div className="w-full max-w-6xl">
              <div className="flex flex-col md:flex-row md:space-x-4">
                <div className="w-full md:w-1/2 mb-6 md:mb-0">
                  <div
                    className="relative flex items-center justify-center h-64 md:h-full md:mb-10 rounded-lg overflow-hidden"
                    style={{
                      backgroundImage: `url(${faculty.image})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                  >
                    <div className="absolute inset-0 bg-black bg-opacity-50"></div>

                    <div className="border-2 border-sdorange inline-block rounded-lg p-2 mx-5">
                      <p className="relative text-white text-xl md:text-2xl font-semibold z-10 text-center px-4">
                        {faculty.closingHead}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="w-full md:w-1/2">
                  <p className="text-sm md:text-base text-gray-700 text-justify md:text-left">
                    {faculty.closingBottom}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FacultyTemplate;

